import React, { useState, useEffect, useContext } from "react";
import ErrorMessage from "./ErrorMessage/ErrorMessage";
import {
  StepperContext,
  EWContext,
} from "../../context/EWContext";

const withErrorHandler = WrappedComponent => props => {
  const [accountState, setAccountState] = useContext(EWContext);
  const setStepperState = useContext(StepperContext)[1];
  const [errorSate, setErrorSate] = useState(false);
  useEffect(() => {
    if(accountState.eligibilityError.error){
      setErrorSate(accountState.eligibilityError);
    }
  }, [accountState.eligibilityError]);

  const{ eligibilityError, submitAttempts, urlToRedirect, errorButtons, groups } = accountState;

  const handleAcceptMessage = () => {
    setErrorSate({ error: false });
    setAccountState((prevAccountState) => ({
      ...prevAccountState,
      ...{ eligibilityError: { error: false } },
    }));

    if (eligibilityError.goStep >= 0) {
      const index = eligibilityError.goStep;
      const newActiveStep = {
        index,
        id: groups[index]?.id || "",
        label: groups[index]?.label || "",
      };

      setStepperState((prevStepperState) => {
        return {
            ...prevStepperState,
            activeStep: newActiveStep,
        };
      });
    }
  };

  return errorSate.error ?
          <ErrorMessage
            message={eligibilityError.message}
            genericMessage={eligibilityError.genericMessage}
            labelButton={eligibilityError.labelButton}
            attempts={submitAttempts}
            urlToRedirect={urlToRedirect}
            onAcceptMessage={handleAcceptMessage}
            errorButtons={errorButtons}
          />
        : <WrappedComponent {...props } />;
};

export default withErrorHandler;
